module.exports = __webpack_public_path__ + "img/cloudCase.4efaf2a4.png";